import Service from "./Service"

class TaskLogService extends Service {

    findById = (id) => this.get(`/task-logs/${id}`)

    search = (queryParams) => this.getWithParams("/task-logs", queryParams)

    getUnfilledDatesOfUser = () => this.get("/task-logs/unfilled")

    createTaskLog = (requestBody) => this.post("/task-logs", requestBody)

    updateTaskLog = (id, requestBody) => this.patch(`/task-logs/${id}`, requestBody)

    deleteTaskLog = (id) => this.del(`/task-logs/${id}`)
}

const tasklogService = new TaskLogService()
export default tasklogService